const CHARSET =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";

/** RFC 7636 code_verifier: 43–128 chars from unreserved set. */
export function createOAuthCodeVerifier(): string {
  const bytes = new Uint8Array(48);
  crypto.getRandomValues(bytes);
  let out = "";
  for (let i = 0; i < bytes.length; i += 1) {
    out += CHARSET[bytes[i]! % CHARSET.length]!;
  }
  return out;
}

export async function createOAuthCodeChallengeS256(verifier: string): Promise<string> {
  if (!globalThis.crypto?.subtle) {
    throw new Error("Нужен защищённый контекст (HTTPS) для входа.");
  }
  const data = new TextEncoder().encode(verifier);
  const digest = await crypto.subtle.digest("SHA-256", data);
  const bytes = new Uint8Array(digest);
  let bin = "";
  for (let i = 0; i < bytes.length; i += 1) {
    bin += String.fromCharCode(bytes[i]!);
  }
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
